import { deepFreeze } from 'utils/deepFreeze';

const initialState = deepFreeze({
  title: '',
  loading: false,
});

export default initialState;
